import { Component, OnInit } from '@angular/core';
import { LogService } from 'src/app/services/log.service';

export const columns = [
  { key: 'projectModule', name: 'PROJECT_MODULE', visible: true },
  { key: 'functionName', name: 'FUNCTION_NAME', visible: true },
  { key: 'operMethod', name: 'OPERATION_METHOD', visible: true },
  { key: 'operResult', name: 'OPERATION_RESULT', visible: true },
  { key: 'errorMsg', name: 'ERROR_MESSAGE', visible: true },
  { key: 'operName', name: 'OPERATION_NAME', visible: true },
  { key: 'createTime', name: 'CREATE_TIME', visible: true },
];


@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss']
})
export class LogComponent implements OnInit {

  dataSource: any[] = [];
  columns: any[] = columns;
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  params = {
    projectModule: '',
    functionName: '',
  };

  isSpinning = false;
  widthConfig = ['13%','13%','16%','13%','13%','13%', '13%'];

  constructor(
    private service: LogService,
  ) { }

  ngOnInit(): void {
    this.getList();
  }

  onSearch() {
    this.pagination.pageIndex = 1;
    this.getList();
  }

  onClear() {
    this.params = {
      projectModule: '',
      functionName: '',
    };
    this.onSearch();
  }
  

  getList() {
    this.isSpinning = true;
    this.service.getTableList({ size: this.pagination.pageSize, current: this.pagination.pageIndex, param: this.params }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { rows, total } = rtnData;
        this.dataSource = rows;
        this.pagination.total = total;
      }
      this.isSpinning = false;
    });
  }

  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

}
